let elementsSelector = 'button, a';
let rippleSelector = '.tippy-tooltip__link, .js-ripple';
let elAttr = 'data-ripple';

prepareElements();
initRipple();

function initRipple() {
	
	if(typeof $.ripple === 'function') {
		
		// https://github.com/jakiestfu/Ripple.js
		
		$.ripple('['+elAttr+'], ' + rippleSelector, {
			// debug: true, // Turn Ripple.js logging on/off
			on: 'click', // The event to trigger a ripple effect
			
			opacity: 0.2, // The opacity of the ripple
			color: "auto", // Set the background color. If set to "auto", it will use the text color
			multi: true, // Allow multiple ripples per element
			
			duration: 0.4, // The duration of the ripple
			
			// Filter function for modifying the speed of the ripple
			rate: function(pxPerSecond) {
				return pxPerSecond;
			},
			
			easing: 'linear' // The CSS3 easing function of the ripple
		});
		
	}
	
}

export function prepareElements() {
	
	let $elements = $(elementsSelector);
	
	$elements.each(function(i, el){
		
		let $el = $(el);
		
		if( !$el.attr(elAttr) && $el.css('display')!=='inline' && !$el.hasClass('flickity-button') ) {
			$el.attr(elAttr, '');
		}
		
	});
	
}